import {Component} from '@angular/core';


@Component({
  selector: 'ricerca-profili-competenze',
  templateUrl: './ricerca-profili-competenze.component.html',
  styleUrls: ['./ricerca-profili-competenze.component.scss'],
})
export class RicercaProfiliCompetenzeComponent {

}

